import { styled } from '@mui/material';
import SimpleSelect from '../select/Select';

export const SortingSelectStyled = styled(SimpleSelect)(({ theme }) => ({
  width: '100%',
  lineHeight: '1rem',
  borderTop: 'transparent',
  borderRight: 'transparent',
  borderBottom: `1px solid ${theme.colors.paragraphText}`,
  borderLeft: 'transparent',
  '& select': {
    color: theme.colors.primaryText,
    backgroundColor: theme.colors.background,
  },
  '& .MuiNativeSelect-icon path': {
    fill: theme.colors.primaryText,
  },
})) as typeof SimpleSelect;
